
import * as hf from './_hf';
import * as ht from './_ht';

//import * as rcl from './_csRcl';

import { useGblz } from './_csGbl';
import { clr } from './_csAbt';


/*
const _sclz = rcl.grtAtom('sclz', { // scale
  nScl: 8,
});
*/

//const _gSclz = useGblz('scl', { nScl: 8 });
//const _gSclz = useGblz('scl', { nScl: 7 });
const _gSclz = useGblz('scl', { nScl: 8.75 });

export const useSclz = () => {
//  const _dz = rcl.grtStt(_sclz);
  const _s = (
    pnSize: ht.n
  ) => {
    return (pnSize ?? 0) * _gSclz.crt.nScl;
  };
  return {
//    ..._dz,
    ... _gSclz,
    set: ( _dz: ht.dz ) => {
      clr();
      _gSclz.set(_dz);
    },
    s: _s,
  }
}
